import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { EmptyState } from "@/components/cards";

export default function WallOfLegends() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/wall-of-legends").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="py-24 text-center text-muted-foreground">Loading…</div>;
  return (
    <div className="max-w-[1200px] mx-auto px-4 lg:px-8 py-14 fade-in text-center">
      <Trophy className="h-12 w-12 text-primary mx-auto" />
      <h1 className="text-4xl md:text-5xl font-display font-bold mt-4">Wall of Legends</h1>
      <p className="text-muted-foreground mt-2">Readers who reached a 100-day streak. True devotion.</p>
      {d.enabled && d.legends.length ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-10">
          {d.legends.map((l, i) => (
            <div key={i} className="p-6 rounded-2xl border border-primary/40 surface-2">
              <div className="h-16 w-16 rounded-full bg-primary/15 grid place-items-center mx-auto text-2xl overflow-hidden">{l.avatar ? <img src={l.avatar} className="h-full w-full object-cover" alt="" /> : "🌟"}</div>
              <p className="font-display font-semibold mt-3">{l.name}</p>
              <p className="text-xs text-primary mt-1">{l.days}-day legend</p>
            </div>
          ))}
        </div>
      ) : <div className="mt-10"><EmptyState icon={Trophy} title="No legends yet" subtitle="Reach a 100-day reading streak to claim your place." /></div>}
    </div>
  );
}
